<template>
  <section class="f-38">
    <m-video
      ref="video"
      muted
      loop
      playsinline
      webkit-playsinline
      poster="@/v2/auto/assets/video/38/poster/0.jpg"
      src="@/v2/auto/assets/video/38/0.mp4"
    />
    <div class="content">
      <div class="title f-center-title">物理仿真</div>
      <div class="title f-center-title">动效轻盈又灵动</div>
      <div class="sub_title f-center-sub-title">
        系统控件的动效反馈加入更多物理仿真的特性，如进度条拖动到尽头时再往外扯，模拟橡皮筋被拉长效果，使虚拟界面更直观，更有真实感
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { videoPlayByVisibleArea } from '@/utils'
export default {
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    const video = this.$refs.video
    video && videoPlayByVisibleArea(video)
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.f-38 {
  width: 100%;
  position: relative;
  overflow: hidden;
  z-index: 79;
  display: flex;
  justify-content: center;
  align-items: center;
  // 避免视频底部出现黑边
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: calc(100% - 20px);
    z-index: 1;
    top: 0;
    left: 0;
    pointer-events: none;
    border-color: #fff;
    border-width: 0;
    border-bottom-width: 20px;
    border-style: solid;
  }
  video {
    position: relative;
    width: 100%;
  }
  .content {
    position: absolute;
    top: 35%;
    left: 20%;
    width: min-content;
    .title {
      width: max-content;
      font-weight: 600;
      line-height: 1.5;
    }
    .sub_title {
      margin-top: 20px;
      line-height: 1.5;
      color: #00000080;
    }
  }
}
</style>
